/** True if the series has at least 2 finite numeric points and is not
 *  flat-zero (which would render a useless flat line). The KPI card draws its
 *  sparkline on this, and `seriesRefsOf` lists the card's series on it, so the
 *  Format pane offers a colour only for a sparkline that is drawn. */
export function sparklineHasSignal(points: readonly (number | null)[] | null | undefined): boolean {
  if (!points || points.length < 2) return false;
  const finite = points.filter((p): p is number => typeof p === "number" && Number.isFinite(p));
  if (finite.length < 2) return false;
  const min = Math.min(...finite);
  const max = Math.max(...finite);
  return !(min === 0 && max === 0);
}
